// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2sloO","label":"Category_label__3YI1D","content":"Category_content__3DhIz","header":"Category_header__3uchd","location":"Category_location__26ICO"};